"use client";

import React from "react";
import type { BaseEntity, EntityWithRelations } from "../types";

interface MobileDetailModalMetadataProps<T extends BaseEntity> {
  item: T;
}

/**
 * Displays metadata (ID, created_at, updated_at) for mobile detail modals
 */
export function MobileDetailModalMetadata<T extends BaseEntity>({
  item,
}: MobileDetailModalMetadataProps<T>) {
  const typed = item as EntityWithRelations<T>;
  return (
    <div className="pt-4 border-t space-y-2 text-xs text-gray-500">
      <div>ID: {item.id}</div>
      {typed.created_at && (
        <div>Created: {new Date(typed.created_at).toLocaleDateString()}</div>
      )}
      {typed.updated_at && (
        <div>Updated: {new Date(typed.updated_at).toLocaleDateString()}</div>
      )}
    </div>
  );
}
